<template>
  <div v-if="!showSeries.series_settings.remove_standings">
    <template v-if="showSeries.series_settings.hide_standings && !viewAdmin  && !isSecretLink">
      <div class="w-4/5 mx-auto  my-3 text-center">
        <h3 class="font-medium text-2xl">Standings are currently hidden for this series.</h3>
        <p>Results will be announced during the awards presentation</p>
      </div>
    </template>
    <template v-else>
      <div class="w-4/5 mx-auto text-sm mb-3">
        <!--<p class=""><span class="font-bold">Current shows included in points:</span> <span v-for="(s, i) in standings_shows" :key="i">{{s}},&nbsp;</span></p>
        -->
        <p class="text-xs text-center font-medium">All Standings Are Unoffical until otherwise stated. If you have questions about individual placings please contact the show  directly.<br>**For overall series standings questions please contact the Show Series directly**</p>
      </div>
      <div class="flex justify-center space-x-5">
        <div class="w-full md:w-1/2" v-if="showSeries.series_settings.has_premier_standings">
          <label for="location" class="block text-lg font-medium text-gray-700 mb-1">Event</label>
          <multiselect @input="eventSelected" ref="show_dropdown" v-model="selectedEvent" :options="eventsInResults" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a category to view the standings" label="name" :preselect-first="false" :custom-label="(option) => {return option.name}" :hideSelected="false">
            <div slot="singleLabel" slot-scope="{ option }" class="text-lg font-">
              {{option.name}}
            </div>
          </multiselect>
        </div>
        <div class="w-full md:w-1/2">
          <label for="location" class="block text-lg font-medium text-gray-700 mb-1">Category</label>
          <multiselect v-if="selectedEvent.event_id === 'Overall'" ref="show_dropdown" v-model="selectedStandings" :options="showSeries.standings.filter(stand => !stand.hidden)" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a category to view the standings" label="name" :preselect-first="false" :custom-label="(option) => {return option.category}" :hideSelected="false">
            <div slot="singleLabel" slot-scope="{ option }" class="text-lg font-">
              {{option.category}}
            </div>
          </multiselect>
          <multiselect v-else ref="show_dropdown" v-model="selectedStandings" :options="seriesStandingsCategories.filter(stand => !stand.hidden)" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a category to view the standings" label="name" :preselect-first="false" :custom-label="(option) => {return option.category}" :hideSelected="false">
            <div slot="singleLabel" slot-scope="{ option }" class="text-lg font-">
              {{option.category}}
            </div>
          </multiselect>
        </div>
      </div>
      <div class="mt-4" v-if="selectedStandings">
        <p class="text-2xl text-center">{{selectedStandings.category}}</p>
        <div class="flex flex-wrap justify-center">
          <div v-for="(d,j) in selectedStandings.divisions" :key="j" class="mb-2 w-full md:w-1/2 ">
            <div class="p-4 m-2  rounded-lg bg-gray-200">
              <p class="text-lg" v-show="selectedStandings.divisions.length > 1">{{d}}</p>

              <div v-for="(r,k) in selectedStandings.standings[d].slice(0,10).filter(e => e.total_points)" :key="k" class="text-sm border-b py-1 flex justify-between">
                <div>
                  <template v-if="k > 0">
                    {{getPlace(r, selectedStandings.standings[d].slice(0,10).filter(e => e.total_points), k)}} - {{r.id}}
                  </template>
                  <template v-else>
                    {{k+1}} - {{r.id}}
                  </template>
                </div>
                <div class="pl-2 font-bold">{{r.total_points}} Points</div>
              </div>
              <div class="flex justify-center my-2">
                <button class="link" @click="showFullStandings(selectedStandings.standings[d], `${selectedStandings.category} ~ ${d}`, selectedStandings.category, selectedStandings.is_overall)">View Full Standings</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <b-modal ref="standingsModal" :title="`Standings: ${fullStandings_label}`">
      <div v-for="(r,k) in fullStandings" :key="k" class="text-sm border-b py-1 ">
        <div class="flex justify-between items-center">
          <div class="flex flex-col">
            <div>
              <template v-if="k > 0">
                {{getPlace(r, fullStandings, k)}} - {{r.id}}
              </template>
              <template v-else>
                {{k+1}} - {{r.id}}
              </template>
            </div>
            <div v-if="r.show_details" class="text-xs md:text-sm">
              <template v-if="!fullStandingIsOverall">
                <div v-for="(s,i) in r.entries" :key="i" class="flex">
                  <div class="w-20 font-bold">{{s.points}} Points</div>
                  <div>{{s.show_name}}</div>
                </div>
              </template>
              <template v-else>
                <div v-for="(s,i) in r.entries" :key="i" class="flex">
                  <div class="w-20 font-bold">{{s.points}} Points</div>
                  <div>{{s.id}} ~ {{s.category}}</div>
                </div>
              </template>
            </div>
          </div>
          <div class="pl-2 font-bold flex flex-col">
            <div>{{r.total_points}} Points</div>
            <div class="link text-xs" @click="r.show_details = !r.show_details">{{r.show_details ? 'Hide' :'Show'}} Details</div>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="w-full">
        <div class="flex justify-end">
          <button class="btn-gray-outline btn-sm" variant="primary" @click="$refs.standingsModal.hide()">
            Close
          </button>
        </div>
      </div>
    </b-modal>
  </div>
  <div v-else>
    <p class="text-2xl mt-4 text-center">Page Not Found</p>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  data () {
    return {
      fullStandings: null,
      fullStandings_label: '',
      fullStandingsCategory: '',
      fullStandingIsOverall: false,
      selectedStandings: null,
      defaultEvent: {name: 'Overall Standings', event_id: 'Overall'},
      selectedEvent: {name: 'Overall Standings', event_id: 'Overall'},
      seriesStandingsCategories: []
    }
  },
  computed: {
    showSeries () {
      return this.$store.state.showSeries_.currentShowSeries
    },
    standings_shows () {
      let shows = []
      this.showSeries.standings.forEach(standing => {
        if (!standing.is_overall) {
          Object.keys(standing.standings).forEach(k => {
            standing.standings[k].forEach(r => {
              r.entries.forEach(e => {
                if (shows.indexOf(e.show_name) === -1) {
                  shows.push(e.show_name)
                }
              })
            })
          })
        }
      })
      return shows
    },
    currentUser () {
      return this.$store.state.user
    },
    viewAdmin () {
      if (this.currentUser) {
        return this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2' || this.currentUser.user_id === this.showSeries.admin_id || this.currentUser.user_id === '9tWzGNjoUZWFjonz2PJJpAnkGxg1'
      } else {
        return false
      }
    },
    isSecretLink () {
      return this.$route.name === 'show_series.standings-secret'
    },
    eventsInResults () {
      let events = [this.defaultEvent]
      this.showSeries.events.filter(e => new Date(e.start_date) <= new Date()).forEach(e => {
        events.push({
          name: e.name,
          event_id: e.event_id
        })
      })
      return events
    }
  },
  methods: {
    showFullStandings (standings, label, category, isOverall) {
      this.fullStandings = standings
      this.fullStandings.forEach(s => {
        Vue.set(s, 'show_details', false)
      })
      this.fullStandings_label = label
      this.fullStandingsCategory = category
      this.fullStandingIsOverall = isOverall
      this.$refs.standingsModal.show()
    },
    getPlace (current, fullStandings, k) {
      let place = k + 1
      let placeSet = false
      if (current.total_points === fullStandings[k - 1].total_points) {
        fullStandings.forEach((s, i) => {
          if (current.total_points === s.total_points) {
            if (!placeSet) {
              place = i + 1
              placeSet = true
            }
          }
        })
      }

      return place
    },
    eventSelected () {
      if (this.selectedEvent.event_id !== 'Overall') {
        this.$store.state.apiInstance.get(`/points?event_id=${this.selectedEvent.event_id}`)
          .then(response => {
            this.$store.state.apiInstance.get(`/points/singleEventStandings?event_id=${this.selectedEvent.event_id}`)
              .then(response => {
                this.seriesStandingsCategories = response.data.data
              })
          })
      }
    }
  }
}
</script>

<style>

</style>
